import FeaturedPlayListIcon from "@mui/icons-material/FeaturedPlayList";

import { resources as ListReportDisPostOffice } from "./ReportDisPostOffice";
import { resources as ListReportDisPostOffice2 } from "./ReportDisPostOffice2";
import { resources as ListReportDisPostOffice3 } from "./ReportDisPostOffice3";
import { resources as ListReportEdition } from "./ReportEditions";
import { resources as ListReportPublishers } from "./ReportPublishers";

export const resources = {
  isMenu: true,
  name: "Reports",
  title: "Абонамент-Справки",
  icon: <FeaturedPlayListIcon />,
  permission: "editions",
  subMenu: [
    ListReportPublishers,
    ListReportEdition,
    ListReportDisPostOffice,
    ListReportDisPostOffice2,
    ListReportDisPostOffice3,
  ],
};
